'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mailCheck = require('./util/mail-check.js');
var personalIdValidation = require('./util/personal-id-validation.js');
var signUpConsent_utils = require('./util/sign-up-consent.utils.js');
var signUpConstants = require('./sign-up-constants.js');
var menuConstants = require('./menu-constants.js');



exports.mailCheck = mailCheck.mailCheck;
exports.getPersonalIdFormatter = personalIdValidation.getPersonalIdFormatter;
exports.getPersonalIdValidator = personalIdValidation.getPersonalIdValidator;
exports.personalIdFormatters = personalIdValidation.personalIdFormatters;
exports.personalIdValidators = personalIdValidation.personalIdValidators;
exports.CONTENT_GROUPS = signUpConsent_utils.CONTENT_GROUPS;
Object.defineProperty(exports, 'EGroupCheckboxState', {
	enumerable: true,
	get: function () {
		return signUpConsent_utils.EGroupCheckboxState;
	}
});
exports.MINIMUM_AGE = signUpConsent_utils.MINIMUM_AGE;
exports.calculateConsentGroupState = signUpConsent_utils.calculateConsentGroupState;
exports.getConsentGroup = signUpConsent_utils.getConsentGroup;
exports.interpolateConsent = signUpConsent_utils.interpolateConsent;
Object.defineProperty(exports, 'SIGN_UP_STEPS', {
	enumerable: true,
	get: function () {
		return signUpConstants.SIGN_UP_STEPS;
	}
});
Object.defineProperty(exports, 'TwoFactorAuthMode', {
	enumerable: true,
	get: function () {
		return signUpConstants.TwoFactorAuthMode;
	}
});
exports.VALID_TFA_VALUES = signUpConstants.VALID_TFA_VALUES;
exports.sanitizeTwoFactorAuthModes = signUpConstants.sanitizeTwoFactorAuthModes;
Object.defineProperty(exports, 'AccountPage', {
	enumerable: true,
	get: function () {
		return menuConstants.AccountPage;
	}
});
